import styled from "styled-components";

export const StripeBox = styled.div``;

export const CheckoutBox = styled.div``;
